export default __webpack_public_path__ + "static/media/download-pdf.8df2497d.png";